import { Outlet, useLocation } from 'react-router';
import { Rail } from './Rail';
import { routes } from './routes';
import { TopBar, type Crumb } from './TopBar';

/** The frame of the pages outside a game: organizations, games, the account pages. The rail carries the mark and the account only. */
export function PlainLayout() {
  const location = useLocation();
  const crumbs: Crumb[] = [{ label: 'Huelency', to: routes.orgs() }];
  const parts = location.pathname.split('/').filter(Boolean);
  if (parts[0] === 'orgs' && parts[1]) crumbs.push({ label: decodeURIComponent(parts[1]), to: routes.games(parts[1]) });
  if (parts[0] === 'orgs' && parts[2] && parts[2] !== 'games') crumbs.push({ label: parts[2] });
  if (parts[0] === 'account') crumbs.push({ label: 'Account', to: routes.account() });
  if (parts[0] === 'account' && parts[1]) crumbs.push({ label: parts[1] });
  return (
    <div className="shell no-panel">
      <Rail />
      <TopBar crumbs={crumbs} />
      <main className="content content-narrow">
        <Outlet />
      </main>
    </div>
  );
}
